<template>
  <div class='aptitude-types'
    :class='{ "is-chart": mode === "chart" }'>
    <svg viewBox='0 0 300 220'>
      <g>
        <g class='boc'
          :class='{
            "is-widget": mode === "widget",
            "is-active": type === "people"
          }'
          @click='$emit("select", "people")'>
          <path
            d='M125 50c0-2.208-1.792-4-4-4h-117c-2.208 0-4 1.792-4 4v77c0 2.208 1.792 4 4 4h117c2.208 0 4-1.792 4-4v-77z'
            fill='url(#5a22deae)'/>
          <path d='M75.5 90.499v-6.252h-1V99h1v-7.501c.772-.014 1.305-.244 1.681-.626.374-.378.598-.928.705-1.646.179-1.206.035-2.95.035-5.102 0-1.434-.354-2.577-1.085-3.44-1.062-1.255-2.964-1.935-5.915-1.935h-.5v1h.5c2.555 0 4.232.495 5.152 1.581.591.699.848 1.634.848 2.794 0 2.09.15 3.784-.024 4.955-.07.47-.183.844-.428 1.091-.216.219-.531.318-.969.328zm-26 1V99h1V84.247h-1v6.252c-.438-.01-.753-.109-.969-.328-.245-.247-.358-.621-.428-1.091-.174-1.171-.024-2.865-.024-4.955 0-1.16.257-2.095.848-2.794.92-1.086 2.597-1.581 5.152-1.581h.5v-1h-.5c-2.951 0-4.853.68-5.915 1.935-.731.863-1.085 2.006-1.085 3.44 0 2.152-.144 3.896.035 5.102.107.718.331 1.268.705 1.646.376.382.909.612 1.681.626zm13-13.999c2.555 0 4.232.495 5.152 1.581.591.699.848 1.634.848 2.794 0 2.09.15 3.784-.024 4.955-.07.47-.184.844-.428 1.091-.139.141-.32.233-.548.282V81.3h-1V99h1v-9.783c.551-.077.956-.286 1.26-.594.373-.378.598-.928.705-1.646.179-1.206.035-2.95.035-5.102 0-1.434-.355-2.577-1.085-3.44-1.001-1.182-2.748-1.855-5.415-1.928V76.5h-1v.007c-2.667.073-4.414.746-5.415 1.928-.73.863-1.085 2.006-1.085 3.44 0 2.152-.144 3.896.035 5.102.107.718.332 1.268.705 1.646.304.308.709.517 1.26.594V99h1V81.3h-1v6.903a1.054 1.054 0 01-.548-.282c-.244-.247-.358-.621-.428-1.091-.174-1.171-.024-2.865-.024-4.955 0-1.16.257-2.095.848-2.794.92-1.086 2.597-1.581 5.152-1.581zM62 88.176V99h1V88.176h-1zM71 70c-1.182 0-1.926.305-2.404.768-.697.676-.846 1.752-.846 2.982 0 2.091 1.481 3.75 3.25 3.75s3.25-1.659 3.25-3.75c0-1.23-.149-2.306-.846-2.982C72.926 70.305 72.182 70 71 70zm-17 0c-1.182 0-1.926.305-2.404.768-.697.676-.846 1.752-.846 2.982 0 2.091 1.481 3.75 3.25 3.75s3.25-1.659 3.25-3.75c0-1.23-.149-2.306-.846-2.982C55.926 70.305 55.182 70 54 70zm17 1c.832 0 1.371.161 1.708.487.524.507.542 1.34.542 2.263 0 1.497-.983 2.75-2.25 2.75s-2.25-1.253-2.25-2.75c0-.923.018-1.756.542-2.263.337-.326.876-.487 1.708-.487zm-17 0c.832 0 1.371.161 1.708.487.524.507.542 1.34.542 2.263 0 1.497-.983 2.75-2.25 2.75s-2.25-1.253-2.25-2.75c0-.923.018-1.756.542-2.263.337-.326.876-.487 1.708-.487zm8.5-3c-1.182 0-1.926.305-2.404.768-.697.676-.846 1.752-.846 2.982 0 2.091 1.481 3.75 3.25 3.75s3.25-1.659 3.25-3.75c0-1.23-.149-2.306-.846-2.982-.478-.463-1.222-.768-2.404-.768zm0 1c.832 0 1.371.161 1.708.487.524.507.542 1.34.542 2.263 0 1.497-.983 2.75-2.25 2.75s-2.25-1.253-2.25-2.75c0-.923.018-1.756.542-2.263.337-.326.876-.487 1.708-.487z'/>
          <g class='cap'
            font-size='6'>
            <text
              x='35.323'
              y='126.08'>
              II. People - driven
            </text>
          </g>
        </g>
        <g class='boc'
          :class='{
            "is-widget": mode === "widget",
            "is-active": type === "people-technology"
          }'
          @click='$emit("select", "people-technology")'>
          <path
            d='M254 50c0-2.208-1.792-4-4-4h-117c-2.208 0-4 1.792-4 4v77c0 2.208 1.792 4 4 4h117c2.208 0 4-1.792 4-4v-77z'
            fill='url(#b41cbd69)'/>
          <path d='M191 87.251v-.008h-1v.008c-2.12.074-3.511.628-4.314 1.577-.599.707-.893 1.644-.893 2.82 0 1.731-.115 3.133.029 4.102.089.6.28 1.058.592 1.374.241.245.557.417.981.491v7.852h1V91.088h-1v5.5a.696.696 0 01-.269-.166c-.183-.185-.263-.467-.315-.819-.139-.935-.018-2.286-.018-3.955 0-.902.196-1.631.656-2.174.723-.853 2.044-1.231 4.051-1.231h.023c1.995.003 3.308.381 4.028 1.231.46.543.656 1.272.656 2.174 0 1.669.121 3.02-.018 3.955-.052.352-.132.634-.315.819a.696.696 0 01-.269.166v-5.5h-1v14.379h1v-7.852c.424-.074.74-.246.981-.491.312-.316.503-.774.592-1.374.144-.969.029-2.371.029-4.102 0-1.176-.294-2.113-.893-2.82-.803-.949-2.194-1.503-4.314-1.577zm10.014 11.202v-5.004h-1v12.018h1v-6.012c.599-.03 1.018-.223 1.319-.528.312-.316.503-.774.592-1.374.144-.97.029-2.372.029-4.102 0-1.176-.294-2.113-.893-2.82-.865-1.022-2.411-1.586-4.814-1.586h-.5v1h.5c2.007 0 3.328.378 4.051 1.232.46.543.656 1.271.656 2.174 0 1.668.121 3.02-.018 3.955-.053.352-.132.633-.315.819-.141.142-.34.21-.607.228zM190 96.597v8.87h1v-8.87h-1zm-10.014 2.858v6.012h1V93.449h-1v5.004c-.267-.018-.466-.086-.607-.228-.183-.186-.262-.467-.315-.819-.139-.935-.018-2.287-.018-3.955 0-.903.196-1.631.656-2.174.723-.854 2.044-1.232 4.051-1.232h.5v-1h-.5c-2.403 0-3.949.564-4.814 1.586-.599.707-.893 1.644-.893 2.82 0 1.73-.115 3.132.029 4.102.089.6.28 1.058.592 1.374.301.305.72.498 1.319.528zm17.324-17.42c-.982 0-1.598.259-1.995.644-.576.558-.708 1.444-.708 2.46 0 1.734 1.235 3.104 2.703 3.104 1.467 0 2.703-1.37 2.703-3.104 0-1.016-.132-1.902-.709-2.46-.397-.385-1.012-.644-1.994-.644zm-13.62 0c-.982 0-1.597.259-1.994.644-.577.558-.709 1.444-.709 2.46 0 1.734 1.236 3.104 2.703 3.104 1.468 0 2.703-1.37 2.703-3.104 0-1.016-.132-1.902-.708-2.46-.397-.385-1.013-.644-1.995-.644zm0 1c.632 0 1.044.114 1.299.362.175.169.265.396.321.652.071.326.083.697.083 1.09 0 1.14-.738 2.104-1.703 2.104-.965 0-1.703-.964-1.703-2.104 0-.393.012-.764.083-1.09.056-.256.146-.483.321-.652.256-.248.667-.362 1.299-.362zm13.62 0c.632 0 1.043.114 1.299.362.175.169.265.396.321.652.071.326.083.697.083 1.09 0 1.14-.738 2.104-1.703 2.104-.965 0-1.703-.964-1.703-2.104 0-.393.012-.764.083-1.09.056-.256.146-.483.321-.652.255-.248.667-.362 1.299-.362zm-6.81-2.602c-.982 0-1.598.259-1.995.643-.576.559-.708 1.445-.708 2.461 0 1.734 1.236 3.103 2.703 3.103 1.467 0 2.703-1.369 2.703-3.103 0-1.016-.132-1.902-.708-2.461-.397-.384-1.013-.643-1.995-.643zm0 1c.632 0 1.044.114 1.299.362.175.169.265.395.321.652.071.326.083.697.083 1.09 0 1.14-.738 2.103-1.703 2.103-.965 0-1.703-.963-1.703-2.103 0-.393.012-.764.083-1.09.056-.257.146-.483.321-.652.255-.248.667-.362 1.299-.362zm6.5-.933h4.55a2.5 2.5 0 100-1H197V73h-1.5v-4.5h5v-1h-6V73H191v-4.05a2.5 2.5 0 10-1 0V73h-6v2h-4.5v-8.55a2.5 2.5 0 10-1 0V76h5.5v3.5h-4.55a2.5 2.5 0 100 1H184v.25h1V74h11v6.75h1v-.25zm7-2a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01204 78.5zm-27 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01177 78.5zm29-13a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm0 1a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01206 66.5zm-3 1h-2v1h2v-1zM190.5 65a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01190.5 65zM179 62.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01179 62.5z'/>
          <g class='cap'
            font-size='6'>
            <text
              x='163.477'
              y='119.58'>
              I. Both People and
            </text>
            <text
              x='160.924'
              y='125.982'>
              Technology - driven
            </text>
          </g>
        </g>
        <g class='boc'
          :class='{
            "is-widget": mode === "widget",
            "is-active": type === "not-people-technology"
          }'
          @click='$emit("select", "not-people-technology")'>
          <path
            d='M125 139c0-2.208-1.792-4-4-4h-117c-2.208 0-4 1.792-4 4v77c0 2.208 1.792 4 4 4h117c2.208 0 4-1.792 4-4v-77z'
            fill='url(#7eb6e5cf)'/>
          <path d='M62.5 148c13.522 0 24.5 10.978 24.5 24.5S76.022 197 62.5 197 38 186.022 38 172.5 48.978 148 62.5 148zm13.11 10.097a2.137 2.137 0 11-2.981 2.981l-5.538 5.538v2.534h3.559a2.138 2.138 0 012.077-1.637 2.138 2.138 0 11-2.077 2.637h-3.559v.204h-1v-2.738l-2.785 2.785c.025.021.048.042.071.064.488.472.607 1.22.607 2.078 0 1.473-1.056 2.631-2.302 2.631-.801 0-1.524-.478-1.938-1.211l-3.082 3.082v.914h-.5c-.145 0-.286.003-.422.008l-2.596 2.596h.844v10.014h-1v-4.925c-.471-.039-.807-.204-1.052-.453-.267-.27-.434-.661-.51-1.175-.067-.453-.066-1.022-.052-1.691l-6.122 6.122C49.547 193.094 55.687 196 62.5 196c12.97 0 23.5-10.53 23.5-23.5 0-6.813-2.906-12.953-7.545-17.248l-2.845 2.845zm-5.235 26.551a.57.57 0 00.341-.151c.138-.14.193-.354.232-.619.114-.762.014-1.864.014-3.223 0-.714-.151-1.291-.515-1.72-.578-.683-1.639-.976-3.245-.976h-.5v-1h.5c2.002 0 3.287.478 4.008 1.33.503.594.752 1.379.752 2.366 0 1.421.094 2.573-.024 3.369-.077.514-.243.905-.51 1.175-.246.249-.581.414-1.053.453v4.925h-1v-10.014h1v4.085zm-8.193-9.153c1.719.075 2.849.541 3.508 1.319.503.594.752 1.379.752 2.366 0 1.422.094 2.573-.024 3.37-.077.513-.243.904-.51 1.175a1.502 1.502 0 01-.777.412v6.44h-1v-11.946h1v4.445a.424.424 0 00.065-.054c.138-.14.193-.354.232-.619.114-.762.014-1.863.014-3.223 0-.713-.151-1.29-.515-1.72-.578-.683-1.639-.975-3.245-.975-1.607 0-2.667.292-3.245.975-.364.43-.516 1.007-.516 1.72 0 1.36-.099 2.461.014 3.223.04.265.095.479.233.619a.47.47 0 00.064.054v-4.445h1v11.946h-1v-6.44a1.495 1.495 0 01-.776-.412c-.267-.271-.434-.662-.51-1.175-.118-.797-.025-1.948-.025-3.37 0-.987.25-1.772.752-2.366.659-.778 1.79-1.244 3.509-1.319v-.01h1v.01zm-1 7.643h1v7.439h-1v-7.439zm13.404-25.431l3.119-3.119A23.4 23.4 0 0062.5 149C49.53 149 39 159.53 39 172.5a23.4 23.4 0 005.588 15.205l6.812-6.812.001-.238c0-.987.25-1.772.752-2.366.612-.723 1.63-1.176 3.148-1.297l.527-.527c-1.119-.159-2.02-1.25-2.02-2.611 0-.859.12-1.606.607-2.078.338-.327.86-.552 1.695-.552.836 0 1.358.225 1.696.552.487.472.607 1.219.607 2.078v.026l.987-.987a2.873 2.873 0 01-.021-.35c0-.858.12-1.606.607-2.078.338-.327.86-.552 1.696-.552.24 0 .454.019.645.053l3.764-3.764v-1.37h-8.818v5.522h-1v-.204h-3.559a2.137 2.137 0 110-1h3.559v-2.682h-4.5v-7.832a2.138 2.138 0 01-1.637-2.077 2.138 2.138 0 014.273 0 2.138 2.138 0 01-1.636 2.077v6.832h3.5v-1.636h4.909v-3.15a2.138 2.138 0 112.636-2.078 2.14 2.14 0 01-1.636 2.078v3.15h2.682v-4.5h5.091v1h-4.091v3.5h1.227v1.37l4.87-4.87h-1.779v-1H72v.961l.239-.239a2.139 2.139 0 012.347-2.347zm-21.598 23.012l-.594.594c-.02 1.059-.073 1.93.021 2.565.04.265.095.479.233.619.083.085.196.13.34.151v-3.929zm1.091-2.505c-.502.159-.887.395-1.163.721a2.075 2.075 0 00-.423.865l1.586-1.586zm13.174-6.99c.836 0 1.358.225 1.696.552.487.472.607 1.219.607 2.078 0 1.473-1.056 2.631-2.303 2.631-1.246 0-2.302-1.158-2.302-2.631 0-.859.12-1.606.607-2.078.338-.327.86-.552 1.695-.552zm0 1c-.485 0-.803.08-.999.27-.131.127-.196.297-.237.488-.057.261-.066.558-.066.872 0 .88.558 1.631 1.302 1.631s1.303-.751 1.303-1.631c0-.314-.009-.611-.066-.872-.042-.191-.107-.361-.237-.488-.196-.19-.514-.27-1-.27zm-11.143 0c-.485 0-.803.08-.999.27-.131.127-.196.297-.237.488-.057.261-.066.558-.066.872 0 .88.558 1.631 1.302 1.631s1.303-.751 1.303-1.631c0-.314-.009-.611-.066-.872-.042-.191-.107-.361-.237-.488-.196-.19-.515-.27-1-.27zm6.485-1.112l-2.101 2.102c.2.559.644.96 1.188.96.744 0 1.302-.751 1.302-1.631 0-.314-.009-.611-.066-.872-.041-.191-.106-.361-.237-.488a.755.755 0 00-.086-.071zm-1.229-.185c-.313.03-.534.111-.684.256-.13.127-.195.297-.237.488a2.286 2.286 0 00-.035.212l.956-.956zm11.361-2.414a1.137 1.137 0 10.003 2.275 1.137 1.137 0 00-.003-2.275zm-22.091 0a1.137 1.137 0 10.003 2.275 1.137 1.137 0 00-.003-2.275zm24.249-9.691l-1.531 1.531a1.137 1.137 0 101.531-1.531zm-13.203.919a1.137 1.137 0 10-.001-2.273 1.137 1.137 0 00.001 2.273zm-9.409-2.046a1.137 1.137 0 10-.001-2.273 1.137 1.137 0 00.001 2.273z'/>
          <g class='cap'
            font-size='6'>
            <text
              x='28.684'
              y='208.58'>
              III. Neither People nor
            </text>
            <text
              x='31.642'
              y='214.982'>
              Technology - driven
            </text>
          </g>
        </g>
        <g class='boc'
          :class='{
            "is-widget": mode === "widget",
            "is-active": type === "technology"
          }'
          @click='$emit("select", "technology")'>
          <path
            d='M254 139c0-2.208-1.792-4-4-4h-117c-2.208 0-4 1.792-4 4v77c0 2.208 1.792 4 4 4h117c2.208 0 4-1.792 4-4v-77z'
            fill='url(#7058d71c)'/>
          <path d='M179.5 159.45V169h5.5v3.5h-4.55a2.5 2.5 0 100 1H185v5.5h1.5v5h-5v1h6v-6h3.5v5.05a2.5 2.5 0 101 0V179h6v-1.5h4.5v8.05a2.5 2.5 0 101 0v-9.05H198v-3h4.55a2.5 2.5 0 100-1H198V166h-1.5v-4.5h5v-1h-6v5.5H192v-4.05a2.5 2.5 0 10-1 0V166h-6v2h-4.5v-8.55a2.5 2.5 0 10-1 0zM203 186.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01203 186.5zm-11.5-1.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01191.5 185zm-15.5-2.5a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm0 1a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01176 183.5zm5 .5h-2v1h2v-1zm16-17v11h-11v-11h11zm-3 8v-5h-5v5h5zm11-3.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01205 171.5zm-27 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01178 171.5zm15-.5v3h-3v-3h3zm14-12.5a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm0 1a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01207 159.5zm-3 1h-2v1h2v-1zm-12.5-2.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 01191.5 158zm-11.5.5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 01180 158.5z'/>
          <g class='cap'
            font-size='6'>
            <text
              x='155.737'
              y='214.98'>
              IV. Technology - driven
            </text>
          </g>
        </g>
        <g class='gri'>
          <g font-size='10'>
            <text
              x='76.04'
              y='7.3'>
              Technology - driven
            </text>
            <text
              x='433.39'
              y='181.69'
              transform='rotate(90 406.875 67.515)'>
              People - driven
            </text>
          </g>
          <g font-size='6'>
            <text
              x='24.199'
              y='40.98'>
              Technology Score: 0 - 22
            </text>
            <text
              x='151.447'
              y='40.98'>
              Technology Score: 23 - 45
            </text>
            <text
              x='407.517'
              y='226.206'
              transform='rotate(90 373.095 112.031)'>
              People Score: 0 - 22
            </text>
            <text
              x='405.756'
              y='137.215'
              transform='rotate(90 373.095 23.04)'>
              People Score: 23 - 45
            </text>
          </g>
          <path d='M248 19.5V17l6 3-6 3v-2.5H0v-1h248z'/>
          <path d='M279.5 52H277l3-6 3 6h-2.5v168h-1V52z'/>
        </g>
        <g class='dot'
          :class='{ "is-widget": mode === "widget" }'
          :transform='`translate(${point.x} ${point.y})`'>
          <path d='M6 208c3.311 0 6 2.689 6 6s-2.689 6-6 6-6-2.689-6-6 2.689-6 6-6zm0 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z'/>
          <text
            x='11.921'
            y='199.464'
            font-size='6'>
            You are
          </text>
          <text
            x='12.354'
            y='208'
            font-size='8'>
            HERE
          </text>
        </g>
      </g>
      <defs>
        <linearGradient
          id='5a22deae'
          x1='0'
          y1='0'
          x2='1'
          y2='0'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(0 -85 57.8 0 62.5 131)'>
          <stop class='stg is-dark-green'
            offset='0'/>
          <stop class='stg is-green'
            offset='0.4'/>
        </linearGradient>
        <linearGradient
          id='b41cbd69'
          x1='0'
          y1='0'
          x2='1'
          y2='0'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(0 -85 57.8 0 191.5 131)'>
          <stop class='stg is-dark-yellow'
            offset='0'/>
          <stop class='stg is-yellow'
            offset='0.4'/>
        </linearGradient>
        <linearGradient
          id='7eb6e5cf'
          x1='0'
          y1='0'
          x2='1'
          y2='0'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(0 -85 57.8 0 62.5 220)'>
          <stop class='stg is-dark-blue'
            offset='0'/>
          <stop class='stg is-blue'
            offset='0.4'/>
        </linearGradient>
        <linearGradient
          id='7058d71c'
          x1='0'
          y1='0'
          x2='1'
          y2='0'
          gradientUnits='userSpaceOnUse'
          gradientTransform='matrix(0 -85 57.8 0 191.5 220)'>
          <stop class='stg is-dark-orange'
            offset='0'/>
          <stop class='stg is-orange'
            offset='0.4'/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
  import { computed } from 'vue'

  export default {
    props: {
      data: Array,
      mode: String
    },

    emits: ['select'],

    setup (props) {
      let type = computed(() => {
        let score = props.data
        if (score[0] <= 22 && score[1] >= 23) return 'people'
        if (score[0] >= 23 && score[1] >= 23) return 'people-technology'
        if (score[0] <= 22 && score[1] <= 22) return 'not-people-technology'
        if (score[0] >= 23 && score[1] <= 22) return 'technology'
        return ''
      })

      let point = computed(() => {
        let score = props.data
        let originX = score[0] <= 22 ? 0 : 129
        let originY = score[1] <= 22 ? 0 : -89
        let width = 113
        let height = 73
        return {
          x: originX + (score[0] % 23) / 22 * width,
          y: originY - (score[1] % 23) / 22 * height
        }
      })

      return { type, point }
    }
  }
</script>

<style lang='scss' scoped>
  @use 'sass:map';
  @use '@/styles/variables';

  .aptitude-types {
    &.is-chart {
      pointer-events: none;
    }
  }

  .boc {
    opacity: 0.4;
    transition: opacity 0.2s ease-in-out;
    fill: white;

    &.is-active {
      opacity: 1;
    }

    &.is-widget {
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }
  }

  .cap {
    font-weight: map.get(variables.$font-weights, 'bold');
  }

  .gri {
    font-weight: map.get(variables.$font-weights, 'bold');
    fill: map.get(variables.$colors, 'gray', '900');
  }

  .dot {
    font-weight: map.get(variables.$font-weights, 'bold');
    fill: map.get(variables.$colors, 'primary', '500');

    &.is-widget {
      display: none;
    }
  }

  .stg {
    @each $name in 'green', 'yellow', 'blue', 'orange' {
      &.is-#{$name} {
        stop-color: map.get(variables.$colors, $name, '500');
      }

      &.is-dark-#{$name} {
        stop-color: map.get(variables.$colors, $name, '700');
      }
    }
  }
</style>
